<ls-title mat-dialog-title>{{ data.header }}</ls-title>
<ls-p level="2" mat-dialog-content [style.min-height.px]="data.minHeightPx">
  <ng-container *ngTemplateOutlet="data.template"></ng-container>
</ls-p>

<div mat-dialog-actions *ngIf="!data.hideActions">
  <button mat-stroked-button *ngIf="data.noText" (click)="onCancelClick()">{{ data.noText }}</button>
  <button mat-flat-button [color]="okayColor" (click)="onOkayClick()">{{ data.yesText }}</button>
</div>
